import React, { Component } from 'react';
import {
  Loader, Dimmer, Segment, Label, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import $ from 'jquery';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import PieChart from '../Extensions/PieChart2';
import Footer from '../Footer/Footer';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import ComponentVersionModal from '../Modal/ComponentVersionModal';
import ComponentRow from './ComponentRow';

class ComponentList extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.componentList = React.createRef();
    this.viewRef = React.createRef();
    const { state } = this.props;
    this.state = {
      pageSize: state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: state.user.view_mode,
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      allComponentList: [],
      activeIndex: [],
      sortValue: '10',
      isSort: false,
      searchKeyword: '',
      startDate: '',
      endDate: '',
      radioValue: 'dttime_any',
      filter: [],
      infoPopupIndex: [],
      popupType: '',
      isOpenCVM: false,
      componentName: null,
      currentComponentVersion: null,
      componentVersionType: 'list',
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: false,
    };
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearRadioValue = this.clearRadioValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.handleCompareAllVersion = this.handleCompareAllVersion.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCVMClose = this.handleCVMClose.bind(this);
    this.handleMoreInfo = this.handleMoreInfo.bind(this);
    this.handleMoreInfoClose = this.handleMoreInfoClose.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { state } = this.props;
    state.user.initPrecisionLevel();
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $contents = $('.contents');
    const $window = $(window);
    let { top } = $contentsHeader.offset();
    $window.on('scroll.contents_header', () => {
      if (!$contentsHeader.hasClass('fixed')) {
        top = $contentsHeader.offset().top;
      }
      if (top - $window.scrollTop() < 140) {
        $contentsHeader.addClass('fixed');
        $contents.css('padding-top', '45px');
      } else {
        $contentsHeader.removeClass('fixed');
        $contents.css('padding-top', 0);
      }
    });
    if (this.componentList) {
      this.getComponentList();
    }
    window.scrollTo(0, 0);

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_box .card_detail_popup_show', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate() {
    const { state } = this.props;
    const { viewMode, pageSize } = this.state;

    const userStore = { ...state.user };

    if (viewMode === '' && userStore.view_mode !== '') {
      this.setState({
        viewMode: userStore.view_mode,
      });
    }

    if (pageSize === '' && userStore.page_limit !== '') {
      this.setState({
        pageSize: userStore.page_limit,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.chart) {
      this.chart.destroy();
    }
  }

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        allComponentList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getComponentList(activePage, pageSize);
      });
    }
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        allComponentList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentList();
      }
    );
  }

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      allComponentList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getComponentList(activePage, pageSize);
    });
  };

  handleOnScroll() {
    const {
      getComponentList,
      state: {
        error, isLoading, hasMore, viewMode, currentPage
      },
    } = this;
    if (viewMode === 'list') {
      return;
    }
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getComponentList(currentPage + 1);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        allComponentList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        allComponentList: [],
        activeIndex: [],
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        filter: value.filter,
        radioValue: value.radio,
      },
      () => {
        this.getComponentList();
      }
    );
  }

  handleCompareAllVersion = (componentName) => {
    let currentComponentVersion;
    const { allComponentList } = this.state;
    const selectedIndex = allComponentList.findIndex((item) => {
      return item.componentName === componentName;
    });

    const currentComponentArray = allComponentList[selectedIndex].componentDetail.components;

    if (currentComponentArray.length === 0) {
      currentComponentVersion = allComponentList[selectedIndex].componentDetail.last_version;
    } else {
      currentComponentVersion = currentComponentArray[0].component_version;
    }

    this.setState({
      isOpenCVM: true,
      componentName,
      currentComponentVersion,
    });
  };

  handleCVMClose = () => {
    this.setState({
      isOpenCVM: false,
    });
  };

  handleMoreInfo = (index, value) => {
    const { infoPopupIndex } = this.state;
    let newState;

    if (infoPopupIndex.indexOf(index) === -1) {
      newState = [...infoPopupIndex, index];
    } else {
      newState = infoPopupIndex;
    }

    this.setState({
      infoPopupIndex: newState,
      popupType: value,
    });
  };

  handleMoreInfoClose = (index) => {
    const { infoPopupIndex } = this.state;
    const newState = infoPopupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      infoPopupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside(event) {
    const { infoPopupIndex, popupType } = this.state;
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (infoPopupIndex.length !== 0 && popupType !== '') {
        return this.setState({
          infoPopupIndex: [],
          popupType: '',
        });
      }
    }
  }

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  toggleRow = (index, componentName) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getComponentDetail(componentName);
      newState = [...activeIndex, index];
    }
    this.setState({
      activeIndex: newState,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      allComponentList: [],
      activeIndex: [],
    }, () => {
      this.getComponentList();
    });
  };

  getComponentList = (pageNo, limit) => {
    let text;
    let filterData;
    const {
      isSort, sortValue, radioValue, pageSize, filter, searchKeyword, startDate, endDate, allComponentList
    } = this.state;
    const { state, t } = this.props;
    ///const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = state.user.page_limit || localStorage.getItem('page_limit');
    }
    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
      filterData = `${filterData},${radioValue}`;
    } else {
      filterData = `${radioValue}`;
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'component_name';
      } else {
        text = 'component_name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'security_count_r';
      } else {
        text = 'security_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'license_count_r';
      } else {
        text = 'license_count';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'title_license';
      } else {
        text = 'title_license_r';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'litigator_count_r';
      } else {
        text = 'litigator_count';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'project_count_r';
      } else {
        text = 'project_count';
      }
      break;
    case sortValue === '8':
      if (isSort) {
        text = 'project_version_count_r';
      } else {
        text = 'project_version_count';
      }
      break;
    case sortValue === '9':
      if (isSort) {
        text = 'uploaded_file_count_r';
      } else {
        text = 'uploaded_file_count';
      }
      break;
    case sortValue === '10':
      if (isSort) {
        text = 'last_detected_r';
      } else {
        text = 'last_detected';
      }
      break;
    default:
      text = 'last_detected';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getComponentList(
            {
              search: searchKeyword,
              filter: filterData,
              detected_start: startDate,
              detected_end: endDate,
              page,
              limit: perPage,
              order: text,
            }
          )
          .then((response) => {
            if (allComponentList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextAllComponentList = response.response.map((item) => {
              return {
                componentName: item.component_name,
                componentVersionCount: item.component_version_count,
                securityCount: item.security_count,
                licenseCount: item.license_count,
                titleLicense: item.title_license,
                litigatorString: item.litigator_string,
                projectCount: item.project_count,
                projectVersionCount: item.project_version_count,
                uploadedFileCount: item.uploaded_file_count,
                lastDetected: item.last_detected,
                hasExploit: item.has_exploit,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              allComponentList: [...allComponentList, ...nextAllComponentList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getComponentDetail = (componentName) => {
    const { t } = this.props;
    const objData = {
      component_name: componentName,
    };

    this.setState({
      isDetailLoading: true,
      isVisible: componentName,
    }, () => {
      api
        .getComponentDetail(objData)
        .then((response) => {
          const { allComponentList } = this.state;
          const data = response.response;
          const updatedIndex = allComponentList.findIndex((item) => {
            return item.componentName === componentName;
          });
          const updatedData = Update(allComponentList[updatedIndex], {
            componentDetail: { $set: data },
          });
          const newData = Update(allComponentList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            allComponentList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  onChangeSorting = (e) => {
    const { sortValue, isSort } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          allComponentList: [],
          activeIndex: [],
        },
        () => {
          this.getComponentList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          allComponentList: [],
          activeIndex: [],
        },
        () => {
          this.getComponentList();
        }
      );
    }
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        allComponentList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getComponentList();
      }
    );
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearRadioValue = () => {
    this.setState(
      {
        allComponentList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getComponentList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        allComponentList: [],
        activeIndex: [],
        filter: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getComponentList();
      }
    );
  };

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        allComponentList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentList();
      }
    );
  }

  renderValue() {
    const {
      filter, radioValue, startDate, endDate
    } = this.state;
    const { t } = this.props;

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const litigatorFilter = filter.filter((item) => {
      return item.indexOf('litigator') > -1;
    });

    const uploadedDateFilter = radioValue;

    const filterObj = {
      security: securityFilter,
      license: licenseFilter,
      litigator: litigatorFilter,
      datetime: uploadedDateFilter,
    };

    return (
      <div>
        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('list.title.security')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('list.title.critical')}
                  {item.indexOf('_h') > -1 && t('list.title.high')}
                  {item.indexOf('_m') > -1 && t('list.title.medium')}
                  {item.indexOf('_l') > -1 && t('list.title.low')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('list.title.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && t('list.title.protective')}
                  {item.indexOf('_pm') > -1 && t('list.title.permissive')}
                  {item.indexOf('_o') > -1 && t('list.title.others')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.litigator.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.litigator')}</strong>
            </span>
            {filterObj.litigator.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_mc') > -1 && 'McHardy'}
                  {item.indexOf('_sf') > -1 && 'SFC'}
                  {item.indexOf('_pt') > -1 && 'Patent Module'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.datetime.indexOf('dttime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('dttime_p24') > -1 && t('contents_header.menu.past_24_hours')}
              {filterObj.datetime.indexOf('dttime_pw') > -1 && t('contents_header.menu.past_week')}
              {filterObj.datetime.indexOf('dttime_pm') > -1 && t('contents_header.menu.past_month')}
              {filterObj.datetime.indexOf('dttime_cr') > -1
                  && `${startDate}~${endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}

        {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  renderChartLabel(obj) {
    const { t } = this.props;
    const { languages } = obj;
    let count = 0;

    if (languages.length > 3) {
      let i = 0;
      for (i; i < languages.length; i++) {
        if (i > 2) {
          count += languages[i].percentage;
        }
      }
    }

    if (languages.length !== 0) {
      return languages.map((item, index) => {
        if (index < 4) {
          return (
            <dl className="" key={item.language.toString()}>
              <dt>
                <Label
                  circular
                  className={cx({
                    first: index === 0,
                    second: index === 1,
                    third: index === 2,
                    fourth: index === 3,
                  })}
                />
                {
                  index === 3 ? t('contents_header.menu.others') : item.language
                }
              </dt>
              <dd>
                {
                  index === 3 ? Math.round(count * 100) / 100 : Math.round(item.percentage * 100) / 100
                }
                %
              </dd>
            </dl>
          );
        }
        return null;
      });
    }
    return null;
  }

  render() {
    const {
      error,
      hasMore,
      isLoading,
      isDetailLoading,
      isVisible,
      allComponentList,
      activeIndex,
      filter,
      sortValue,
      isSort,
      radioValue,
      infoPopupIndex,
      popupType,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      isRenderListOnly,
      isOpenCVM,
      componentName,
      currentComponentVersion,
      componentVersionType,
      isOpenWarnModal,
      startDate,
      endDate,
      searchKeyword,
      totalCount
    } = this.state;

    const {
      location, state, params, t, navigate
    } = this.props;

    return (
      <div ref={this.componentList}>
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          radioValue={radioValue}
          totalCount={totalCount}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          handleSearchChange={this.handleSearchChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          startDate={startDate}
          endDate={endDate}
          navigate={navigate}
          searchKeyword={searchKeyword}
        />
        <div className="content">
          {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : null}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <table className="wide_card_table wide_card_scope">
                <colgroup>
                  <col style={{ width: '3.9%', maxWidth: '36px' }} />
                  <col style={{ width: '22.1%', maxWidth: '200px' }} />
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '40.7%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '4.3%', maxWidth: '40px' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th className="checkbox_wrap tal">
                      <div className="checkbox" />
                    </th>
                    <th className="tal">
                      <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.component')}
                        {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="tal">
                      <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.component_version')}
                        {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="sum_th">
                      <table>
                        <colgroup>
                          <col style={{ width: '39.7%' }} />
                          <col style={{ width: '34.7%' }} />
                          <col style={{ width: '14%' }} />
                          <col style={{ width: '11.7%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="3"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.security_risk')}
                                {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="4"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.license')}
                                {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="5"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.title_license')}
                                {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="6"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.litigator')}
                                {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </th>
                    <th className="sum_th tac">
                      <table>
                        <colgroup>
                          <col style={{ width: '32.35%' }} />
                          <col style={{ width: '' }} />
                          <col style={{ width: '32.35%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="7"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.project')}
                                {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="8"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.project_version')}
                                {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                            <th className="tac">
                              <a
                                className="sorting_button"
                                data-id="9"
                                onClick={this.onChangeSorting}
                                onKeyUp={this.onChangeSorting}
                              >
                                {t('list.title.uploaded_files')}
                                {isSort && sortValue === '9' ? <img src={upIcon} alt="" /> : ''}
                                {!isSort && sortValue === '9' ? <img src={downIcon} alt="" /> : ''}
                              </a>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </th>
                    <th className="tac">
                      <a className="sorting_button" data-id="10" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.last_detected')}
                        {isSort && sortValue === '10' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortValue === '10' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>&nbsp;</th>
                  </tr>
                </tbody>
              </table>
              {allComponentList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box wide_card_type_04"',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: infoPopupIndex.indexOf(index) >= 0,
                      },
                    )}
                    key={item.componentName.toString()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '22.1%', maxWidth: '200px' }} />
                        <col style={{ width: '57%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.componentName);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td
                            className="border-none tal"
                            style={{
                              maxWidth: '200px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            <strong>{item.componentName}</strong>
                          </td>
                          <td className="tal sum_td" colSpan="4">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '10.1%' }} />
                                <col style={{ width: '58.3%' }} />
                                <col style={{ width: '21.5%' }} />
                                <col style={{ width: '10.4%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{item.componentVersionCount}</td>
                                  <td className="sum_td tac">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '41.1%' }} />
                                        <col style={{ width: '36%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">
                                            <div className="belt_chart">
                                              <div className="red">
                                                {item.securityCount.critical}
                                              </div>
                                              <div className="orange">
                                                {item.securityCount.high}
                                              </div>
                                              <div className="cheese">
                                                {item.securityCount.medium}
                                              </div>
                                              <div className="yellow">{item.securityCount.low}</div>
                                            </div>
                                            {
                                              item.hasExploit ? (<Icon name="bug" />) : null
                                            }
                                          </td>
                                          <td className="tac">
                                            <div className="belt_chart round">
                                              <div className="red">
                                                {item.licenseCount.protective}
                                              </div>
                                              <div className="cheese">
                                                {item.licenseCount.permissive}
                                              </div>
                                              <div className="yellow">
                                                {item.licenseCount.others}
                                              </div>
                                            </div>
                                          </td>
                                          <td className="tac">{item.titleLicense}</td>
                                          <td className="tac">{item.litigatorString}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="sum_td tac">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '32.35%' }} />
                                        <col style={{ width: '34.3%' }} />
                                        <col style={{ width: '32.35%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">{item.projectCount}</td>
                                          <td className="tac">{item.projectVersionCount}</td>
                                          <td className="tac">{item.uploadedFileCount}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="tac" id="smallText">
                                    {item.lastDetected}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a className="expand_button">
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.componentName ? (
                            <tr>
                              <td className="border-none" colSpan="7">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.componentName} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="border-none">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="4">
                                {
                                  item.componentDetail
                                && (
                                  <ComponentRow
                                    childRef={this.viewRef}
                                    parentRowData={item.componentDetail}
                                    uid={item.uploadedFileId}
                                    t={t}
                                    state={state}
                                    location={location}
                                    params={params}
                                  />
                                )
                                }
                              </td>
                              <td className="border-none tal">&nbsp;</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.componentDetail ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top">
                          <p className="title">{t('list.title.written_in')}</p>
                          <PieChart chartData={item.componentDetail} translate={t} />
                          {this.renderChartLabel(item.componentDetail)}
                        </div>
                        <div className="wide_card_detail_bottom">
                          {/*<a className="card_detail_popup_show" data-type="1">Mtach Detail</a>*/}
                          <a
                            className={cx('card_detail_popup_show', {
                              active: infoPopupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleMoreInfo(index, 'type_0');
                            }}
                            onKeyUp={() => {
                              return this.handleMoreInfo(index, 'type_0');
                            }}
                          >
                            {t('list.title.more_information')}
                          </a>
                          {
                            item.componentDetail.last_version ? (
                              <a
                                className="card_detail_popup_show"
                                style={{ cursor: 'pointer' }}
                                onClick={() => { return this.handleCompareAllVersion(item.componentName); }}
                                onKeyUp={() => { return this.handleCompareAllVersion(item.componentName); }}
                              >
                                <Icon name="external alternate" />
                                <span>{t('list.title.compare_all_versions')}</span>
                              </a>
                            ) : (
                              <a
                                className="card_detail_popup_show"
                                style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                              >
                                <Icon name="external alternate" />
                                <span>{t('list.title.compare_all_versions')}</span>
                              </a>
                            )
                          }
                          {
                            item.componentDetail.last_version ? (
                              <a
                                className="card_detail_popup_show"
                                data-type="0"
                                style={{ cursor: 'auto' }}
                              >
                                {t('list.title.lates_version')}
                                (
                                {item.componentDetail.last_version}
                                )
                              </a>
                            ) : null
                          }
                        </div>
                      </div>
                    ) : null}
                    {item.componentDetail ? (
                      <div
                        className={cx('card_detail_popup card_detail_popup_1', {
                          show: infoPopupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                        })}
                      >
                        <div className="popup_box">
                          <h3 className="popup_header">
                            {t('list.title.more_information')}
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMoreInfoClose(index);
                              }}
                              onKeyUp={() => {
                                return this.handleMoreInfoClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <div className="type_3">
                                <dl>
                                  <dt>{t('list.title.group_id')}</dt>
                                  <dd className="text_ellipsis">{item.componentDetail.more_info.group_id}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('list.title.artifact_id')}</dt>
                                  <dd>{item.componentDetail.more_info.artifact_id}</dd>
                                </dl>
                                {item.componentDetail.more_info && item.componentDetail.more_info.url && (
                                  <div>
                                    <div className="line" />
                                    {
                                      item.componentDetail.more_info.url.homepage
                                      && (
                                        <dl>
                                          <dt>{t('modal.component_detail.homepage')}</dt>
                                          <dd>
                                            <em>{item.componentDetail.more_info.url.homepage}</em>
                                          </dd>
                                        </dl>
                                      )
                                    }
                                    {
                                      item.componentDetail.more_info.url.download
                                      && (
                                        <dl>
                                          <dt>{t('list.title.origin_list')}</dt>
                                          {
                                            item.componentDetail.more_info.url.download.map((url) => {
                                              return (
                                                <dd key={uuidv4()}>
                                                  <em>{url}</em>
                                                </dd>
                                              );
                                            })
                                          }
                                        </dl>
                                      )
                                    }
                                  </div>
                                )}
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {/*
                      <div className="card_detail_popup card_detail_popup_2">
                        <div className="popup_box">
                          <table className="wide_card_table wide_card_item">
                            <colgroup>
                              <col style={{ width: '12%' }} />
                              <col style={{ width: '14%' }} />
                              <col style={{ width: '9%' }} />
                              <col style={{ width: '' }} />
                              <col style={{ width: '20px' }} />
                            </colgroup>
                            <tr>
                              <td className="tac">
                                92.9%
                              </td>
                              <td>
                                strongswan
                              </td>
                              <td>
                                4.6.4
                              </td>
                              <td className="sum_td">
                                <table className="sub_table">
                                  <colgroup>
                                    <col style={{ width: '40%' }} />
                                    <col style={{ width: '35%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '' }} />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <div className="belt_chart">
                                        <div className="red">{item.licenseCount.protective}</div>
                                        <div className="orange">{item.licenseCount.protective}</div>
                                        <div className="cheese">{item.licenseCount.protective}</div>
                                        <div className="yellow">{item.licenseCount.protective}</div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="belt_chart round">
                                        <div className="red">{item.licenseCount.protective}</div>
                                        <div className="cheese">{item.licenseCount.protective}</div>
                                        <div className="yellow">{item.licenseCount.protective}</div>
                                      </div>
                                    </td>
                                    <td>
                                      GPL
                                    </td>
                                    <td>
                                      GPL-2.0+
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td className="border-none">
                                &nbsp;
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    */}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && allComponentList.length !== 0
                && (
                  <div style={{ marginTop: '10px', textAlign: 'center' }} className="clar_pagination">
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <ComponentVersionModal
          isOpenCVM={isOpenCVM}
          closeModal={this.handleCVMClose}
          componentName={componentName}
          currentComponentVersion={currentComponentVersion}
          componentVersionType={componentVersionType}
          translate={t}
        />
        <Modal open={isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ComponentList))));
